import { Globe } from '@phosphor-icons/react';
import React, { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { createSafeContext } from './ui/utils';

import { Option, Select } from '~/components/ui/select';
import { LanguageState } from '~/contexts/lang/languageContext';
import { Language } from '~/interfaces/Language';
import { RootState } from '~/utils/store';


const [SafeLanguageProvider, useLangContext] = createSafeContext<
  Omit<LanguageState, 'setLanguage'> & {
    setLanguage: (lang: Language) => void;
  }
>('Language Context Error');

const LOCAL_STORAGE_LANG_KEY = 'lang';
const language = JSON.parse(localStorage.getItem('lang') ?? 'null');
export const DEFAULT_LANGUAGE = { name: 'English', code: 'en', id: 19 };

export { useLangContext };
export function LanguageProvider(props: Readonly<{ children: React.ReactNode }>) {

  const [selectedLanguage, setSelectedLanguage] = useState(
    language ?? DEFAULT_LANGUAGE,
  );

  const languageChangeHandler = useCallback((value: Language) => {
    setSelectedLanguage(value);
    const stringifiedLanguage = JSON.stringify(value);

    localStorage.setItem(LOCAL_STORAGE_LANG_KEY, stringifiedLanguage);
  }, []);

  return (
    <SafeLanguageProvider
      {...props}
      value={{ selectedLanguage: selectedLanguage, setLanguage: languageChangeHandler }}
    />
  );
}

export function LanguageSelect(
  props: Readonly<Omit<React.ComponentPropsWithoutRef<typeof Select>, 'startDecorator'>>,
) {
  const ctx = useLangContext();

  const tenantLanguages = useSelector(
    (state: RootState) => state.tenant.languages,
  );

  return (
    <Select
      {...props}
      startDecorator={<Globe />}
      placeholder='Select Language'
      onChange={(_e, value) => {
        if (value && typeof value === 'object') {
          ctx.setLanguage(value as Language);
          const stringifiedLanguage = JSON.stringify(value);

          localStorage.setItem(LOCAL_STORAGE_LANG_KEY, stringifiedLanguage);
        }
      }}
      value={ctx.selectedLanguage}
    >
      {tenantLanguages.map((item) => (
        <Option key={item.id} value={item.code}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
}
